import styled from 'styled-components';

export const Container = styled.div`
    & .breadcrumb {
        margin-bottom: 3px;
        font-size: 0.8em;
    }

    & .breadcrumb a {
        text-decoration: none!important;
    }
`